export const DISTANCE = 'store_widget.icon.distance';
export const DIRECTIONS = 'store_widget.get_directions';
